<div class="breadcrumb-wrapper">
    <nav>
        <ol>
            <li *ngFor="let crumb of breadcrumbItems; let isLast = last; let i = index">
                <span class="crumb">
                    <a *ngIf="!isLast" (click)="onBreadcrumbClick(crumb, i)">{{ crumb.display }}</a>
                    <span *ngIf="isLast" class="last-crumb">{{ crumb.display }}</span>
                    <span *ngIf="!isLast" class="divider">&#47;</span>
                </span>
            </li>
        </ol>
    </nav>
</div>
